import fetch from '@/util/http'

export default {
  pageVip(model) {
    return fetch.get('vip/page', model)
  },
  isVip() {
    return fetch.get('membervip/isVip')
  },
  registerVip(model) {
    return fetch.post('memberVipOrder/mobileOrder', model)
  }
}



// WEBPACK FOOTER //
// ./src/api/vip.js